import * as angular from "angular";

import { SmokeTestController } from "../../controllers";

/**
 * Component for performing basic smoke test about salaxy libraries:
 * Are all the libraries and dependencies loaded and functional in the package.
 */
export class SmokeTest implements angular.IComponentOptions {

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to controller implementation
   */
  bindings = {
    /** Defines the view / set of tests: "core" or "ng1" */
    mode: "@",
  };

  /** Uses the SalaxySmokeTestController */
  public controller = SmokeTestController;

  /** Teh template URL */
  public templateUrl = "salaxy-components/test/SmokeTest.html";
}
